import type { IPartnerSettings } from '.'

export const Respect: IPartnerSettings = {
  partner: 'Respect',
  origAppUrl: {
    development: 'https://localhost/Car.Web.Client.Respect',
    test: 'https://www.kara-kal.cz/test2',
    prep: '',
    production: 'https://www.kara-kal.cz/prod'
  },
  hosts: [
    'kara-kal.cz'
    , 'www.kara-kal.cz'
    // , 'localhost:44470'
  ]
}
